import React, { useState, useEffect } from 'react';
import api from './services/api';

export default function AdminMessages() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      const response = await api.get('/contact/messages');
      setMessages(response.data);
    } catch (err) {
      setError(err.response?.data?.error || err.message || "Failed to fetch messages");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="text-center py-8">Loading messages...</div>;
  }

  if (error) {
    return (
      <div className="text-center py-8 text-raya-text-tertiary">
        Error: {error}
        <button onClick={fetchMessages} className="ml-4 text-raya-accent underline">Retry</button>
      </div>
    );
  }

  return (
    <div className="bg-raya-card rounded-lg shadow-sm overflow-hidden border border-raya-border">
      <div className="p-6 border-b border-raya-border bg-raya-bg-off">
        <h2 className="text-2xl font-bold text-raya-text-primary">Contact Messages</h2>
      </div>
      
      {messages.length === 0 ? (
        <div className="p-8 text-center text-raya-text-tertiary">
          No messages found.
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead className="bg-raya-bg-off text-raya-text-tertiary uppercase text-xs font-bold">
              <tr>
                <th className="px-6 py-3">Date</th>
                <th className="px-6 py-3">Name</th>
                <th className="px-6 py-3">Email</th>
                <th className="px-6 py-3">Subject</th>
                <th className="px-6 py-3">Message</th>
              </tr>
            </thead>
            <tbody className="divide-y border-raya-border">
              {messages.map((msg) => (
                <tr key={msg.id} className="hover:bg-raya-accent/5 transition">
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-raya-text-secondary">
                    {new Date(msg.created_at).toLocaleDateString()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap font-medium text-raya-text-primary">
                    {msg.name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-raya-accent font-semibold">
                    <a href={`mailto:${msg.email}`}>{msg.email}</a>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-raya-text-secondary">
                    {msg.subject}
                  </td>
                  <td className="px-6 py-4 text-sm text-raya-text-secondary max-w-xs truncate" title={msg.message}>
                    {msg.message}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
